import { render, staticRenderFns } from "./AdultSeat.vue?vue&type=template&id=32928005&scoped=true"
import script from "./AdultSeat.vue?vue&type=script&lang=js"
export * from "./AdultSeat.vue?vue&type=script&lang=js"
import style0 from "./AdultSeat.vue?vue&type=style&index=0&id=32928005&prod&lang=scss&scoped=true"
import style1 from "./AdultSeat.vue?vue&type=style&index=1&id=32928005&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32928005",
  null
  
)

export default component.exports